import styles from "./Letter.module.css";
import { letter, letterToAnonymousClaimant } from "../../constants/messages";
import { useSelector } from "react-redux";

function Letter() {
  let isAnon = useSelector((state) => state.app.isAnonymous);

  return (
    <>
      {!isAnon ? (
        <div className={styles.container}>
          <p>{letter}</p>
        </div>
      ) : (
        <div className={styles.anonContainer}>
          <p> {letterToAnonymousClaimant}</p>
        </div>
      )}
    </>
  );
}

export default Letter;
